export * from './src/data-v1-data-service-data.meta.js';
